import { SAMPLE_STATES, sampleState } from '@/api/resources/entityState/sample-state'
import { PORTION_STATES, portionState } from '@/api/resources/entityState/portion-state'
import { SUBPORTION_STATES, subportionState } from '@/api/resources/entityState/subportion-state'
import { EntityState } from '@/api/resources/entityState/entity-state'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { keyBy, merge } from 'lodash'
import { store } from '@/store/store'

export const SHIPMENT_ENTITY_STATES = {
    ...SAMPLE_STATES,
    ...PORTION_STATES,
    ...SUBPORTION_STATES
}

class ShipmentEntityState extends EntityState {
    protected get entityName(): string {
        return 'shipment-entity'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            await Promise.all([
                sampleState.loadStates(),
                portionState.loadStates(),
                subportionState.loadStates()
            ])
            const states = [
                ...sampleState.states,
                ...portionState.states,
                ...subportionState.states
            ]
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(
                    merge(
                        keyBy(states, 'code'),
                        keyBy(SHIPMENT_ENTITY_STATES, 'code')))
            }
            await store.dispatch('setEntityState', entityState)
        }
    }
}

export const shipmentEntityState = new ShipmentEntityState()
